
import {
  HomeFilled,
  SettingOutlined,
  UserOutlined,
  UsergroupAddOutlined,
  DollarOutlined,
  CreditCardOutlined,
  StockOutlined,
  AppstoreOutlined
} from '@ant-design/icons';
import { langPage } from "../locales";

export const menus: Array<any> = [
  {
    title: langPage?.home.name,
    name: "home",
    path: "/home",
    icon: <HomeFilled />,
    privilegeCode: 'home',
    children: []
  },
  {
    title: langPage?.mine.name,
    name: "mine",
    path: "/mine",
    icon: <AppstoreOutlined />,
    privilegeCode: '',
    children: []
  },
  {
    title: langPage?.amount.name,
    name: "amount",
    path: "/amount",
    icon: <DollarOutlined />,
    privilegeCode: "amount",
    children: [
      {
        title: "用户地址",
        path: "/amount/userAddress",
        name: "userAddress",
        privilegeCode: "userAddress",
      },
      {
        title: "网络转账列表",
        path: "/amount/userTransfer",
        name: "userTransfer",
        privilegeCode: "networkTransfer",
      },
      {
        title: langPage?.amount.recharge.name,
        path: "/amount/recharge",
        name: "recharge",
        privilegeCode: "recharge",
      },
      {
        title: langPage?.amount.withdrawal.name,
        path: "/amount/withdrawal",
        name: "withdrawal",
        privilegeCode: "withdrawal",
      },
      {
        title: langPage?.amount.balanceLog.name,
        path: "/amount/balanceLog",
        name: "balanceLog",
        privilegeCode: "balanceLog",
      },
    ]
  },
  {
    title: langPage?.card.name,
    name: "card",
    path: "/card",
    icon: <CreditCardOutlined />,
    privilegeCode: "card",
    children: [
      {
        title: langPage?.card.name,
        path: "/card/cardMain",
        name: "cardMain",
        privilegeCode: "cardMain",
      },
      {
        title: '实体卡申请',
        path: "/card/apply",
        name: "apply",
        privilegeCode: "apply",
      },
      {
        title: langPage?.card.product.name,
        path: "/card/product",
        name: "product",
        privilegeCode: "product",
      },
      {
        title: langPage?.card.record.name,
        path: "/card/cardRecord",
        name: "cardRecord",
        privilegeCode: "cardRecord",
      },
      {
        title: langPage?.card.transaction.name,
        path: "/card/cardTransaction",
        name: "cardTransaction",
        privilegeCode: "cardTransaction",
      },
      {
        title: '持卡人列表',
        path: "/card/holder",
        name: "holder",
        privilegeCode: "holder",
      },
      {
        title: "卡卡转账列表",
        path: "/card/transfer",
        name: "transfer",
        privilegeCode: "transfer", // todo transfer
      }
    ]
  },
  {
    title: langPage?.level.name,
    name: "level",
    path: "/level",
    icon: <StockOutlined />,
    privilegeCode: "level",
    children: []
  },
  {
    title: langPage?.member.user.name,
    path: "/member/user",
    icon: <UsergroupAddOutlined />,
    name: "user",
    privilegeCode: "user",
  },
  {
    title: langPage?.member.name,
    name: "member",
    path: "/member",
    icon: <UserOutlined />,
    privilegeCode: "member",
    children: [
      {
        title: langPage?.member.manager.name,
        path: "/member/manager",
        name: "manager",
        privilegeCode: "manager",
      },
      {
        title: langPage?.member.role.name,
        path: "/member/role",
        name: "role",
        privilegeCode: "role",
      },
      {
        title: '权限管理',
        path: "/member/privilege",
        name: "privilege",
        privilegeCode: "privilege",
      },
    ]
  },
  {
    title: langPage?.settings.name,
    name: "settings",
    path: "/settings",
    icon: <SettingOutlined />,
    privilegeCode: "settings",
    children: [
      {
        title: langPage?.settings.notice?.notice,
        path: "/settings/notice",
        name: "notice",
        privilegeCode: "notice",
      },
      {
        title: langPage?.settings.config?.name,
        path: "/settings/config",
        name: "config",
        privilegeCode: "config",
      },
    ]
  },
];
